// extracted by mini-css-extract-plugin
export var cardHeader = "_ru-0";
export var reorderHandle = "_ru-3";
export var titleArea = "_ru-1";
export var titleAreaWithHandle = "_ru-2";